import { Navigate, useLocation } from 'react-router-dom';
import { SignInCard } from '@kawai/auth-bootstrap';
import { useAuth } from '../lib/auth.js';

interface LocationState {
  from?: string;
}

/**
 * S-89: フォーム本体は @kawai/auth-bootstrap の SignInCard に共通化（inline style）。
 * S-137: 見た目は v2（SignInCard variant / tokens.css + ui-v2.css は index.css が取り込む）。
 *
 * - 既にサインイン済みなら遷移元（or '/'）に redirect。
 * - role 判定は SaasAdminGuard 側で行う。
 * - 本社内部向けのためテナント名・問い合わせ先メールは表示しない。
 */
export function SignInPage() {
  const { status, signIn } = useAuth();
  const location = useLocation();
  const fromPath = (location.state as LocationState | null)?.from ?? '/';

  if (status === 'signed-in') {
    return <Navigate to={fromPath} replace />;
  }

  return (
    <SignInCard
      logoSrc="/brand/tracepit-logo.png"
      appTitle="管理コンソール"
      description="カワイ本社 SaaS 管理者アカウントでサインインしてください"
      accountNote="アカウントは管理者が発行します。アカウントの発行・パスワードの再設定は、システム運用担当にお問い合わせください。"
      signIn={signIn}
      variant="v2"
    />
  );
}
